"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PageData_1 = __importDefault(require("./PageData"));
var EventDispatcher_1 = __importDefault(require("../EventDispatcher"));
//import JSFunctions from "../libs/JSFunctions" ;
var maximomAcceptableParamsOnURL = 50;
var allPages = [];
var PageManager = {
    dispatcher: new EventDispatcher_1.default(),
    PAGE_CHANGED: "PAGE_CHANGED",
    routerParamList: '',
    changePage: changePage,
    decodePageParams: decodePageParams,
    getCurrentPage: getCurrentPage,
    registerPage: registerPage,
    lastPage: lastPage,
};
for (var i = 0; i < maximomAcceptableParamsOnURL; i++) {
    PageManager.routerParamList += '/:p' + i + '?';
}
///Page list ↓
function registerPage(page) {
    allPages.push(page);
}
var cashedLastPage = new PageData_1.default();
function changePage(targetPage, pageData) {
    if (pageData === void 0) { pageData = []; }
    if (targetPage !== null) {
        cashedLastPage = JSON.parse(JSON.stringify(targetPage));
        for (var i = 0; i < pageData.length; i++) {
            if (pageData[i] === undefined || pageData[i] === null || pageData[i] === '') {
                pageData[i] = '~';
            }
            cashedLastPage.url += '/' + encodeURIComponent(pageData[i]);
        }
        PageManager.dispatcher.dispatchEvent(PageManager.PAGE_CHANGED, cashedLastPage);
    }
}
/**@description pass the constructor's props to the function and retrive parameters list */
function decodePageParams(props) {
    if (props === void 0) { props = {}; }
    if (props !== undefined &&
        props.match !== undefined &&
        props.match.params !== null) {
        var params = [];
        for (var i = 0; i < maximomAcceptableParamsOnURL; i++) {
            var par = props.match.params['p' + i];
            if (par !== undefined) {
                if (par === '~')
                    par = null;
                try {
                    params.push(decodeURIComponent(par));
                }
                catch (e) { }
                ;
            }
            else
                break;
        }
        return params;
    }
    return null;
}
/**@return {PageData} */
function getCurrentPage() {
    /**@type {string} */
    var currentLocation = window.location.href.toLowerCase();
    for (var i = 0; i < allPages.length; i++) {
        /**@type {string} */
        var testLoc = allPages[i].url;
        if (currentLocation.indexOf(testLoc) !== -1) {
            return allPages[i];
        }
    }
    return null;
}
function lastPage() {
    window.history.back();
}
exports.default = PageManager;
//# sourceMappingURL=PageManager.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/saffroncodejs/lib/framework/pageManager/PageManager.js
// module id = 104
// module chunks = 0